import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_CAMPAIGN_STICKY_COLUMNS,
  UPDATE_CAMPAIGN_STICKY_COLUMNS,
} from "./actionTypes"

import {
  getCampaignStickyColumnsSuccess,
  getCampaignStickyColumnsError,
  updateCampaignStickyColumnsSuccess,
  updateCampaignStickyColumnsError
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* onGetCampaignStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_campaigns`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getCampaignStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getCampaignStickyColumnsError(error))
  }
}

function* onUpdateCampaignStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_campaigns/${action?.payload?.user_column_preference_campaign?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateCampaignStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateCampaignStickyColumnsError(error))
  }
}

function* userCampaignColumnPreferenceSaga() {
  yield takeEvery(GET_CAMPAIGN_STICKY_COLUMNS, onGetCampaignStickyColumns)
  yield takeEvery(UPDATE_CAMPAIGN_STICKY_COLUMNS, onUpdateCampaignStickyColumns)
}

export default userCampaignColumnPreferenceSaga;
